import { observer } from 'mobx-react-lite'
import { DownloadImage } from 'blaze-ui/icons/36/DownloadImage'
import { Action, ActionProps } from './Action'
import { useExportToZip } from 'components/ExportModal/hooks/useExportToZip'
import { ArticleFlat } from 'types'

export const DownloadPostMediaOnly = observer(({ ...props }: ActionProps & { article: ArticleFlat }) => {
  const { exportToZip } = useExportToZip(props.article.id)

  const handleClick = () => {
    exportToZip({ mediaOnly: true })
  }

  return <Action icon={DownloadImage} onPress={handleClick} {...props} />
})
